import type { ReactNode } from "react";

export const AlertList = ({
  items,
  title,
}: {
  title: ReactNode;
  items: string[];
}) => {
  return (
    <div>
      {title}
      <ul
        css={{
          padding: "0px",
          paddingLeft: "14px",
        }}
      >
        {items.map((item) => (
          <li>{item}</li>
        ))}
      </ul>
    </div>
  );
};
